import MainContainer from '../../../components/MainContainer'
import { headerPersonnalEvalutaion } from '../../../data/modules/personnal-evaluation-header'
// import EmployeeListFiltre from './EmployeeListFiltre';
import EmployeeListTable from './EmployeeListTable'

const Resultats = () => {
  
  return (
    <MainContainer {...headerPersonnalEvalutaion}>
      <EmployeeListTable title={"Resultat de l'evaluation"} />
    </MainContainer>
  )
}

export default Resultats